export const CHANNEL = 'NDS';
export const SEARCH_TYPE = 'manual';

export const EVENT_TYPES = {
  CLEAR_ALL_CLICK: 'clear-all-click',
  FILTERS_UPDATED: 'filters-updated',
};

export const CLICK_INTERACTION_IDENTIFIER = 'isPLPClickInteracted';
